import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, In, getManager, QueryRunner } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, FgStatusEnum, GlobalVariableValues, LotStatusEnum, LotTypeEnum, operationEntryTypeEnum, OperationTypeEnum, ProductionProcessTypeEnum, ShiftsEnum, spsaPrevOperationEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { LotCodeOpsRepository } from './repositories/lot-code.repository';
import { LotCodeOpsAdapter } from './dto/lot-code.adapter';
import { LotCodeOpsEntity } from './entities/lot-code.entity';
import { LotCodeOpsDTO } from './dto/lot-code.dto';
import { LotCodeOpsRequest } from './dto/lot-code-request';
import { AllLotCodeOpsResponseModel, AssignLotMaterialReq, LotCodeDropDown, LotCodeDropDownResponse, LotCodeOpsData, LotCodeOpsResponseModel, LotCreationReq, LotInfoReportReq, MaterialInfoReq, OperationandLotReq } from '@gtpl/shared-models/production-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApiGatewayTimeoutResponse } from '@nestjs/swagger';
import { CommonResponse, MasterInfoFromIndentRequest, MasterInfoFromIndentResponse, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { SuppliersService } from '@gtpl/shared-services/masters';
import { SoSoItemRequest } from './dto/lot-no-for-so.request';
import appSettings from 'apps/services/config';
import { ItemsDetails, SaleOrderItemsDropdownResponse, SoNumbersModel, SoNumbersResponseModel } from '@gtpl/shared-models/sale-management';
import { SoIdRequest } from './dto/so-id.request';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LotInfoEntity } from './entities/lot-info.entity';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const lotCodeTable = appSettings.production_db + '.lot_code_data';
@Injectable()
export class LotCodeOpsService {
  constructor(
    @InjectRepository(LotCodeOpsRepository)
    private lotCodeOpsRepo: LotCodeOpsRepository,
    private lotCodeOpsAdapter: LotCodeOpsAdapter,
    private saleOrderService: SaleOrderService,
    private supplierService: SuppliersService,
  ) { }

  async getLotCodeOpsDetailsWithoutRelations(lotNumber: string): Promise<LotCodeOpsEntity> {
    // tslint:disable-next-line: typedef
    const lotCodeOpsResponse = await this.lotCodeOpsRepo.findOne({
      where: { lotNumber: Raw(alias => `lot_number = '${lotNumber}'`) },
    });
    if (lotCodeOpsResponse) {
      return lotCodeOpsResponse;
    } else {
      return null;
    }
  }

  async createLotCodeOps(lotCodeOpsDto: LotCodeOpsDTO, isUpdate: boolean): Promise<LotCodeOpsResponseModel> {
    // console.log(statesDto);

    try {
      // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      if (!isUpdate) {
        // const lotCodeOpsEntity = await this.getLotCodeOpsDetailsWithoutRelations(lotCodeOpsDto.lotNumber);
        const lotCodeOpsEntity = await this.lotCodeOpsRepo.findOne({ lotNumber: lotCodeOpsDto.lotNumber });

        if (lotCodeOpsEntity && isUpdate) {
          lotCodeOpsEntity.testResult = lotCodeOpsDto.testResult;
          //return new InformationMessageError(11104, "State already exists");
          throw new ErrorResponse(11104, 'LotCodeOps already exists');
        }
      }
      else {
        const lotCodeOpsEntity = await this.getLotCodeOpsDetailsWithoutRelations(lotCodeOpsDto.lotNumber);
        if (lotCodeOpsEntity) {
          if (lotCodeOpsEntity.lotNumber != lotCodeOpsDto.lotNumber) {
            throw new ErrorResponse(11104, 'LotCodeOps already exists');
          }   
        }
      }
      const convertedLotCodeOpsEntity: LotCodeOpsEntity = this.lotCodeOpsAdapter.convertDtoToEntity(lotCodeOpsDto, isUpdate);
      const savedLotCodeOpsEntity: LotCodeOpsEntity = await this.lotCodeOpsRepo.save(
        convertedLotCodeOpsEntity
      );
      const savedlotCodeOpsDto: LotCodeOpsDTO = this.lotCodeOpsAdapter.convertEntityToDto(convertedLotCodeOpsEntity);
      // console.log(savedStateDto);
      if (savedlotCodeOpsDto) {
        // generating resposnse
        const response = new LotCodeOpsResponseModel(true, 1, isUpdate ? 'LotCodeOps Updated Successfully' : 'LotCodeOps Created Successfully');
        return response
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'LotCodeOps saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      return error;
    }
  }

  // async getAllLotOps(plantId: number): Promise<AllLotCodeOpsResponseModel> {
  //   // const page: number = 1;
  //   // try {
  //   //   const lotCodeOpsDTO: LotCodeOpsData[] = [];
  //   //   //retrieves all companies
  //   //   const lotCodeOpsEntity = await this.lotCodeOpsRepo.getAllLotData(plantId)
  //   //   // console.log('lotcodeData-------',lotCodeOpsEntity,'>>>>>>>>>');
  //   //   if (lotCodeOpsEntity.length === 0) {
  //   //     throw new ErrorResponse(10000, 'No Records Found');
  //   //   }
  //   //   for (const lotData of lotCodeOpsEntity) {
  //   //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: lotData.saleOrderId })
  //   //     const soREq: saleOrder = {
  //   //       saleOrderId: lotData.saleOrderId
  //   //     }
  //   //     const soItemInfo = await this.saleOrderService.getSaleOrderItemsForSo(soREq);
  //   //     const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(lotData.farmer, lotData.farmerCode, 1, 1, 1));
  //   //     console.log(lotData.grnDate,'--data--')
  //   //      lotCodeOpsDTO.push(new LotCodeOpsData(
  //   //        lotData.lotCodeOpsId, 
  //   //        lotData.grnDate, 
  //   //        lotData.indentId, 
  //   //        lotData.grnNumber,
  //   //        lotData.lotNumber,
  //   //        lotData.saleOrderId,
  //   //        soInfo.saleOrderNumber, 
  //   //        lotData.saleOrderItemId,
  //   //        soItemInfo?.data?.itemsDetails[0]?.item,
  //   //        lotData.supplierType,
  //   //        lotData.farmer,
  //   //        lotData.farmerCode,
  //   //        lotData.quantity,
  //   //        lotData.count,
  //   //        lotData.price,
  //   //        lotData.boxes,
  //   //        lotData.plantId,
  //   //        lotData.subPlantId,
  //   //        lotData.createdAt, 
  //   //        lotData.createdUser,
  //   //        lotData.updatedAt,
  //   //        lotData.updatedUser,
  //   //        lotData.isActive,
  //   //        lotData.versionFlag,
  //   //        masterResponse?.data?.farmerName,
  //   //        masterResponse?.data?.farmerCode,
  //   //        masterResponse?.data?.supplierName, 
  //   //        masterResponse?.data?.supplierCode,
  //   //        soInfo.poNumber,
  //   //        lotData.concatLotNum))
  //   //     console.log(lotCodeOpsDTO,'dto');
  //   //   }
  //   //   const response = new AllLotCodeOpsResponseModel(true, 1, 'Lot Code Info retrieved successfully', lotCodeOpsDTO);
  //   //   // console.log(response,'^^^^^^^^^^');
  //   //   // const newLogDto = new LogsDto(1,'view', 'Countries', 0, true, '','')
  //   //   //       let res = await this.logService.createLog(newLogDto);
  //   //   //       console.log(res);
  //   //   return response;

  //   // } catch (err) {
  //   //   return err;
  //   // }
  //   try{
  //   const manager = getManager();
  //   const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'g.plant_lot_number' : 'g.lot_number'
  //   let query 
  //   const planttype='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
  //   const result =await manager.query(planttype);
  //   query ='SELECT g.remarks as plantLotNumber,b.brand_name,f.name AS farmerName,f.code AS farmerCode,sd.po_number AS poNumber,CONCAT(b.brand_name,"-",sk.variant_code) AS itemName,sk.variant_code,CONCAT(g.lot_number,IF(g.remarks IS NOT NULL,"-",""),IF(g.remarks IS NOT NULL ,g.remarks ,"")) AS concatLotNum,lc.lot_code_id AS lotCodeOpsId ,lc.grn_date AS grnDate,lc.plant_id AS plantId,lc.sub_plant_id AS subPlantId,lc.indent_no AS indentId,lc.grn_number AS grnNumber,lc.lot_number AS lotNumber,lc.sale_order_id AS saleOrderId, lc.sale_order_item_id AS saleOrderItemId,lc.supplier_type AS supplierType ,lc.farmer AS farmer,lc.farmer_code AS farmerCode ,lc.quantity AS quantity,lc.count AS count, lc.price AS price ,lc.boxes AS boxes FROM '+appSettings.production_db+'.lot_code_data lc LEFT JOIN '+appSettings.rm_procure_db+'.grn_items g ON '+grnItemColumn+' = lc.lot_number LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sd ON lc.sale_order_id = sd.sale_order_id LEFT JOIN '+appSettings.sales_db+'.`sale_order_items` si ON si.sale_order_id=lc.sale_order_id LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.sku_code_id=si.varient_id LEFT JOIN '+appSettings.masters_db+'.brands b ON b.brand_id=si.brand_id LEFT JOIN '+appSettings.masters_db+'.farms f ON f.farm_id=lc.farmer WHERE lot_code_id>0 '
  //     if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
  //       query = query + ' and sub_plant_id='+plantId+' group by lot_code_id'
  //     }
  //     // if(plantId && plantId!=5){
  //     //   query=query +' and plant_id='+plantId+' and sub_plant_id=0 group by lot_code_id'
  //     // }
  //     else{
  //       if( plantId!=5){
  //         query=query +' and plant_id='+plantId+' and sub_plant_id=0 group by lot_code_id'
  //       }else{
  //         query=query +' and sub_plant_id=0 group by lot_code_id'
  //       }
  //     }  
  //     const data = await manager.query(query)
  //     if(data.length > 0){
  //       return new AllLotCodeOpsResponseModel(true,1000,'DataRetrieved sucesfullyy....',data)
  //     }else{
  //       return new AllLotCodeOpsResponseModel(false,1000,'No Data Found',data)

  //     }

  //   }
  //   catch(err){
  //     return err;
  //   }
  // }

    async getAllLotOps(plantId?: number,lotType?:string): Promise<CommonResponse> {
    try{
    const manager = getManager();
    const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'g.plant_lot_number' : 'g.lot_number'
    let query 
    const planttype=`select plant_type from ${appSettings.masters_db}.unitcodes where unit_code_id=${plantId}`;
    const result =await manager.query(planttype);
    query =`SELECT id,lot_number AS lotNumber,lot_type AS lotType,li.remarks,status,variant_id,quality,quantity,exfactory_date as exFactoryDate,priority,CASE WHEN lot_type!='Bale' THEN p.name ELSE sku.short_code END AS varientName,li.date as lotCreatedDate
FROM ${appSettings.production_db}.lot_info li
LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=variant_id AND lot_type!='Bale'
LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id=variant_id AND lot_type='Bale'

WHERE 1=1`
if(lotType){
  query = query + ` and lot_type='${lotType}'`
}
      query += ` GROUP BY lot_number`
      const data = await manager.query(query)
      if(data.length > 0){
        return new CommonResponse(true,1000,'DataRetrieved sucesfullyy....',data)
      }else{
        return new CommonResponse(false,1000,'No Data Found',data)

      }

    }
    catch(err){
      return err;
    }
  }

  async activateOrDeactivateprodInv(lotCodeOpsRequest: LotCodeOpsRequest): Promise<LotCodeOpsResponseModel> {
    try {
      const lotCodeOpsExists = await this.getLotCodeOpsById(lotCodeOpsRequest.lotCodeOpsId);
      if (lotCodeOpsExists) {
        if (lotCodeOpsRequest.versionFlag !== lotCodeOpsExists.versionFlag) {
          throw new ErrorResponse(10113, 'Someone updated the current lotCodeOps information.Refresh and try again');
        } else {

          const lotCodeOpsStatus = await this.lotCodeOpsRepo.update(
            { lotCodeOpsId: lotCodeOpsRequest.lotCodeOpsId },
            { isActive: lotCodeOpsRequest.isActive, updatedUser: lotCodeOpsRequest.updatedUser });

          if (lotCodeOpsExists.isActive) {
            if (lotCodeOpsStatus.affected) {
              const lotCodeOpsResponse: LotCodeOpsResponseModel = new LotCodeOpsResponseModel(true, 10115, 'lotCodeOps is de-activated successfully');
              return lotCodeOpsResponse;
            } else {
              throw new ErrorResponse(10111, 'lotCodeOps is already deactivated');
            }
          } else {
            if (lotCodeOpsStatus.affected) {
              const lotCodeOpsResponse: LotCodeOpsResponseModel = new LotCodeOpsResponseModel(true, 10114, 'lotCodeOps is activated successfully');
              return lotCodeOpsResponse;
            } else {
              throw new ErrorResponse(10112, 'lotCodeOps is already  activated');
            }
          }
          // }
        }
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }

  async getLotCodeOpsById(lotCodeOpsId: number): Promise<LotCodeOpsEntity> {
    //  console.log(employeeId);
    const Response = await this.lotCodeOpsRepo.findOne({
      where: { lotCodeOpsId: lotCodeOpsId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getLotNumbersForBeheading(): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getLotNumbersForBeheading();
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  async getAllLotNumbers(req?: UnitRequest): Promise<LotCodeDropDownResponse> {
    try {
      // const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getAllLotNumbers(plantId);
    
      const manager = getManager()
    // const result =await manager.getManager();

      let data=`SELECT lot_code_id AS lotCodeId,l.lot_number AS lotNumber ,l.sub_plant_id AS subPlantId,CONCAT(l.lot_number,IF(g.remarks IS NOT NULL,'-',''),IF(g.remarks IS NOT NULL,g.remarks,'')) AS conacatlotnplantlot,g.remarks AS plantlotNumber FROM `+appSettings.production_db+`.lot_code_data l LEFT JOIN `+appSettings.rm_procure_db+`.grn_items g ON g.lot_number=l.lot_number `
      if(req.unitId){
        data=data +' where l.plant_id='+req.unitId+' GROUP BY l.lot_number'
      }  
      const lotCodes = await manager.query(data)

      if (lotCodes && lotCodes.length ) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  

  async getSaleOrders(): Promise<SoNumbersResponseModel> {
    try {
      const manager = getManager();
      const query = `SELECT so.sale_order_id as saleOrderId, CONCAT(so.sale_order_no, " - ", inv.po_number) AS saleOrderNumber FROM ` + lotCodeTable + ` s 
      LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id 
      LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.sale_order_id 
      group by s.sale_order_id`;

      const soEntities: SoNumbersModel[] = await manager.query(query);
      if (soEntities && soEntities.length > 0) {
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      return error;
    }
  }

  async getSaleOrderItemsForSo(req: SoIdRequest): Promise<SaleOrderItemsDropdownResponse> {
    try {
      const manager = getManager();
      const query = `SELECT s.sale_order_item_id as saleOrderItemId, concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item FROM ` + lotCodeTable + ` s 
          LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id 
          LEFT JOIN `+ appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
          LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
          LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
          where s.sale_order_id=`+ req.saleOrderId + `
          group by s.sale_order_item_id`;

      const soEntities: ItemsDetails[] = await manager.query(query);
      if (soEntities && soEntities.length > 0) {
        const response = new SaleOrderItemsDropdownResponse(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      return error;
    }
  }

  async getAllLotNumbersForSoItem(req: SoSoItemRequest): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getAllLotNumbersForSoItem(req);
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }
  async getSonumberforQaQcrejection(req:OperationandLotReq): Promise<CommonResponse> { 
      const manager = getManager();

      let query
      const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
      const plantresult =await manager.query(plantquery);
      query='SELECT pi.sale_order_item_id as saleOrderItemId,operation,sub_lot_number as subLotNumber,pi.plant_id plantId,pi.sub_plant_id,op_boxes,pi.lot_number as lotNumber,(physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity) AS availableQuantity,physical_quantity AS physicalQuantity,si.po_number,variant_code,pi.sale_order_id as saleOrderId,lot_number,CONCAT(si.po_number,"-",variant_code) AS salOrderandItem FROM '+appSettings.production_db+'.production_inventory pi LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON si.sale_order_id=pi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items soi ON soi.sale_order_item_id=pi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk ON sk.sku_code_id=soi.varient_id where pi.sub_lot_number ="'+req.subLotNumber+'" and pi.operation="'+req.operation+'"'

      if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
        query = query+' and pi.sub_plant_id='+req.plant+' '
      }else{
          query = query+ ' and pi.plant_id='+req.plant+' and  pi.sub_plant_id=0' 
      }
      query = query+' group by pi.sale_order_item_id'

      // const query = 'SELECT CONCAT(si.po_number,"-",b.brand_name,"-",sk.variant_code) AS product,b.brand_name AS brandName,sk.variant_code AS variantCode,si.job_type AS jobtype,ld.sale_order_id AS saleOrderId,ld.sale_order_item_id AS saleOrderItemId,so.sale_order_no AS saleOrderNumber,si.po_number AS poNumber FROM '+appSettings.production_db+'.lot_code_data ld LEFT JOIN  '+appSettings.sales_db+'.sale_order so ON ld.sale_order_id=so.sale_order_id LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON ld.sale_order_id=si.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items soi ON ld.sale_order_id=soi.sale_order_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk ON sk.sku_code_id = soi.varient_id LEFT JOIN '+appSettings.masters_db+'.`brands` b ON b.brand_id = soi.brand_id WHERE si.is_sub_contract="NO" AND si.job_type!="Sub Job" GROUP BY ld.sale_order_item_id'
      
      const data= await manager.query(query);
      if (data.length > 0) {
        return new CommonResponse(true, 5555, 'So lifecylce data retrivedd', data)
      } else {
        return new CommonResponse(false, 4444, 'No lifecylce data found')
      }
  }

  async createLot(req:LotCreationReq):Promise<CommonResponse>{
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    try{
        await transManager.startTransaction()

        const getMaxRefNoQry = `SELECT MAX(ref_no) as refNo FROM ${appSettings.production_db} .lot_info WHERE lot_type = '${req.lotType}'`
        const refNoInfo = await transManager.query(getMaxRefNoQry)
        const refNo = refNoInfo.length > 0 ? Number(refNoInfo[0].refNo) + 1 : 1
        const entityObj = new LotInfoEntity()
        entityObj.lotType = req.lotType
        entityObj.remarks = req.remarks
        entityObj.refNo = refNo
        entityObj.lotNumber = req.lotType == LotTypeEnum.Carding ? `C-${String(refNo).padStart(3,'0')}` : req.lotType == LotTypeEnum.Dressing ?  `D-${String(refNo).padStart(3,'0')}` : `BL-${String(refNo).padStart(3,'0')}`
        entityObj.status = LotStatusEnum.OPEN
        entityObj.date = req.date
        entityObj.createdUser = req.createdUser
        entityObj.exFactoryDate = req.exFactoryDate
        entityObj.priority = req.priority
        entityObj.year =  new Date(req.date).getFullYear();
        const save = await transManager.manager.getRepository(LotInfoEntity).save(entityObj)
        if(save){
            await transManager.commitTransaction()
            await transManager.release()
            return new CommonResponse(true,1,'Lot Created Successfully')
        }else{
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in lot creation')
        }
    }catch(err){
        await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'Something went wrong',err)
    }
  }

  async getOpenLotsInfo():Promise<CommonResponse>{
    const manager = getManager()
    try{
        const getQry = `SELECT lot_number as lotNumber,lot_type as lotType,remarks,exfactory_date as exFactoryDate,priority,date as lotDate,year FROM ${appSettings.production_db} .lot_info WHERE status = '${LotStatusEnum.OPEN}' AND lot_type IN ('${LotTypeEnum.Carding}','${LotTypeEnum.Dressing}','${LotTypeEnum.Blowing}')`
        const lotInfo = await manager.query(getQry)

        if(lotInfo.length > 0){
            return new CommonResponse(true,1,'Data retrieved',lotInfo)
        }else{
            return new CommonResponse(false,0,'No data found')
        }

    }catch(err){
        throw err
    }
  }

  async getMaterialForLot(req:MaterialInfoReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      // let getQry = `SELECT p.work_order_no as workOrderNumber,p.physical_quantity - p.issued_quantity - p.clubbed_qty as quantity,p.quality,pro.name as variant,p.physical_quantity - p.issued_quantity as lotQuantity,
      // p.prod_inv_id as prodInvId,p.plant_id as plantId,
      // p.physical_quantity as degumOutQty,p.physical_quantity + p.wip_quantity as degumInQty,p.variant_id as variantId,wo.exfactory_date as exFatcoryDate
      // FROM ${appSettings.production_db} .production_inventory p
      // LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = p.variant_id
      // LEFT JOIN ${appSettings.rm_procure_db} .work_order_info wo ON wo.work_order_no = p.work_order_no
      // WHERE p.physical_quantity - p.issued_quantity - p.clubbed_qty > 0 and operation = '${OperationTypeEnum.DEGUMMING}' AND lot_number = 'N/A' AND p.entry_type = '${operationEntryTypeEnum.OUT}'`
      let getQry = `SELECT p.prod_inv_id as prodInvId,p.plant_id as plantId,p.work_order_no as workOrderNumber,p.quality,p.variant_id as variantId,SUM(p.wip_quantity + p.wastage_quantity + p.physical_quantity) AS degumInQty,
      SUM(p.physical_quantity) AS degumOutQty,SUM(p.physical_quantity - p.issued_quantity - p.clubbed_quantity) AS quantity,pro.name as variant,wo.exfactory_date as exFatcoryDate,SUM(p.physical_quantity - p.issued_quantity - p.clubbed_quantity) AS lotQuantity,
      product.name AS degumOutVariant 
      FROM ${appSettings.production_db} .production_inventory p 
      LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = p.variant_id
      LEFT JOIN ${appSettings.rm_procure_db} .work_order_info wo ON wo.work_order_no = p.work_order_no
      LEFT JOIN ${appSettings.masters_db} .products product ON product.product_id = p.out_product
      WHERE  p.operation = '${spsaPrevOperationEnum.DEGUMMING}' AND p.lot_number = 'N/A' AND p.is_qaqc_two_approved IS TRUE 
      `
      if(req.workOrderNumber != undefined){
        getQry += ` AND p.work_order_no IN (${req.workOrderNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.variant != undefined){
        getQry += ` AND p.variant_id IN (${req.variant.map(item => `'${item}'`).join(',')})`
      }
      if(req.quality != undefined){
        getQry += ` AND p.quality IN (${req.quality.map(item => `'${item}'`).join(',')})`
      }
      if(req.plantId != undefined){
        getQry += ` AND p.plant_id = ${req.plantId}`
      }
      getQry +=  ` GROUP BY p.work_order_no,p.quality,p.variant_id HAVING quantity > 0  ORDER BY wo.exfactory_date,p.work_order_no `

      const materialInfo = await manager.query(getQry)
      if(materialInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',materialInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async assignMaterialAgainstLot(req:AssignLotMaterialReq[]):Promise<CommonResponse>{
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    try{
      await transManager.startTransaction()
      // const getInfoQry = `SELECT g.grn_date,i.indent_id,g.grn_number,i.supplier_type,bi.agent_id,i.indent_id FROM ${appSettings.rm_procure_db} .work_order_info w 
      // LEFT JOIN ${appSettings.rm_procure_db} .work_order_items wi ON wi.work_order_id = w.id
      // LEFT JOIN ${appSettings.rm_procure_db} .bale_items bi ON bi.id = wi.bale_item_id
      // LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_item_id = bi.inward_item_id
      // LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id
      // LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id`
      // const getInfo = await transManager.query(getInfoQry)

      const saveFlag = new Set<boolean>()

      let totQty = 0
      for(const rec of req){
        const entityObj = new LotCodeOpsEntity()
        entityObj.createdUser = rec.createdUser
        entityObj.lotNumber = rec.lotNumber
        entityObj.mainLotNum = rec.lotNumber
        entityObj.plantId = rec.plantId
        entityObj.quantity = rec.quantity
        entityObj.variantId  = rec.variantId
        entityObj.quality = rec.quality
        entityObj.workOrderNo = rec.workOrderNumber
        entityObj.year = rec.year
        // entityObj.farmer = getInfo[0].agent_id
        // entityObj.grnDate = getInfo[0].grn_date
        // entityObj.grnNumber = getInfo[0].grn_number
        // entityObj.indentId = getInfo[0].indent_id
        // entityObj.supplierType = getInfo[0].supplier_type
        totQty += Number(rec.quantity)

        const save = await transManager.manager.save(entityObj)
        if(save){
          saveFlag.add(true)
        }else{
          saveFlag.add(false)
          await transManager.rollbackTransaction()
          await transManager.release()
          return new CommonResponse(false,0,'Something went wrong in updating assign material against lot')
        }
      }
      // console.log(totQty,'totqty')
      if(!(saveFlag.has(false))){
        const updateStatus = await transManager.manager.getRepository(LotInfoEntity).update({lotNumber:req[0].lotNumber},{status:LotStatusEnum.ASSIGNED,variantId:req[0].lotVariantId,quantity:totQty,quality:req[0].lotQuality,materialAssignDate:req[0].date})
        if(updateStatus.affected){
          let saveFlag = new Set<Boolean>()
          for(let i=1 ;i<=2;i++){
            const prodObj = new ProductionInventory()
            prodObj.createdUser = req[0].createdUser
            prodObj.lotNumber = req[0].lotNumber
            prodObj.operation = OperationTypeEnum.DEGUMMING
            if(i ==1){
              prodObj.wipQuantity = 0
              prodObj.entryType = operationEntryTypeEnum.IN
              prodObj.inputQuantity = totQty
            }else{
              prodObj.physicalQuantity = totQty
              prodObj.entryType = operationEntryTypeEnum.OUT
              prodObj.outProduct = req[0].lotVariantId
            }
            prodObj.plantId = req[0].plantId
            prodObj.prevOperation = OperationTypeEnum.DEGUMMING
            prodObj.processType = ProductionProcessTypeEnum.FRESHPRODUCITON
            prodObj.prevOperation = OperationTypeEnum.DEGUMMING
            prodObj.subLotNumber = req[0].lotNumber
            prodObj.variantId = req[0].lotVariantId
            prodObj.product = req[0].lotVariant
            prodObj.quality = req[0].lotQuality
            prodObj.year = req[0].year
  
            // console.log('prodObj',prodObj)  
            
            const saveProdObj = await transManager.manager.getRepository(ProductionInventory).save(prodObj)
  
            if(saveProdObj){
              saveFlag.add(true)
                        // job number generation 
              let today = new Date();
              let CurrentYear = today.getFullYear();
              let CurrentMonth = today.getMonth();
              let fromDate = 0;
              let toDate = 0;
              let totalRecords = await (await transManager.manager.getRepository(ProductionLog).find({ where: { operationType: OperationTypeEnum.DEGUMMING } })).length;
  
  
              if (CurrentMonth < 4) {
                fromDate = (CurrentYear-1);
                toDate = (CurrentYear);
              } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
              }
  
              totalRecords = totalRecords + 1;
  
              var refNo = totalRecords + "";
              while (refNo.length < 4) refNo = "0" + refNo;
              const jobNo = 'LOT' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
  
              const prodLogObj = new ProductionLog()
              prodLogObj.createdUser = req[0].createdUser
              prodLogObj.date = req[0].date
              prodLogObj.lotNumber = req[0].lotNumber
              prodLogObj.shift = ShiftsEnum.General
              prodLogObj.prodInvId = saveProdObj.productionInventoryId
              prodLogObj.operationType = OperationTypeEnum.DEGUMMING
              prodLogObj.jobNumber = jobNo
              prodLogObj.variantId = req[0].variantId
              prodLogObj.prevOperation = OperationTypeEnum.DEGUMMING
              prodLogObj.plantId = req[0].plantId
              prodLogObj.subLotNumber = req[0].lotNumber
              prodLogObj.variantId = req[0].lotVariantId
              prodLogObj.product = req[0].lotVariant
              prodLogObj.quality = req[0].lotQuality
              prodLogObj.year = req[0].year
              if(i ==1){
              prodLogObj.inputQuantity = totQty
              prodLogObj.entryType = operationEntryTypeEnum.IN
              }else{
                prodLogObj.actualOutputQuantity = totQty
                prodLogObj.entryType = operationEntryTypeEnum.OUT
                prodLogObj.outProduct = req[0].lotVariantId
              }
              
              const saveProdLog = await transManager.manager.getRepository(ProductionLog).save(prodLogObj)
  
              if(saveProdLog){
                saveFlag.add(true)
                
              }else{
                saveFlag.add(false)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,'Something went wrong in saving Production Log')
              }
            }else{
              saveFlag.add(false)
              await transManager.rollbackTransaction()
              await transManager.release()
              return new CommonResponse(false,0,'Something went wrong in saving Production Inventory')
            }
            
          }

          if(!(saveFlag.has(false))){
            const updateFlag = new Set<boolean>()
            for(const rec of req){
                const updateIssuedQty = await transManager.manager.getRepository(ProductionInventory).update({workOrderNo:rec.workOrderNumber,variantId:rec.variantId,quality:rec.quality,entryType:operationEntryTypeEnum.OUT},{issuedQuantity:() => `issued_quantity + ${rec.quantity}`})
                if(updateIssuedQty.affected){
                  updateFlag.add(true)
                }else{
                  updateFlag.add(false)
                  await transManager.rollbackTransaction()
                  await transManager.release()
                  return new CommonResponse(false,0,'Something went wrong in updating issued qty at previous record')
                }
              }
              if(!(updateFlag.has(false))){
                await transManager.commitTransaction()
                await transManager.release()
                return new CommonResponse(true,1,'Material assigned successfully against the lot')
              }else{
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,'Something went wrong in updating issued qty at previous record')
              }
          }else{
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating issued quantity')
          }
        }else{
          await transManager.rollbackTransaction()
          await transManager.release()
          return new CommonResponse(false,0,'Something went wrong in updating status against lot')
        }
      }else{
        await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'Something went wrong in updating assign material against lot')
      }
    }catch(err){
      await transManager.rollbackTransaction()
      await transManager.release()
      return new CommonResponse(false,0,'Something went wrong')
    }
  }

  async getWorkOrderDropdown():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getQry = ` SELECT (work_order_no) as workOrderNumber FROM ${appSettings.production_db} .production_inventory WHERE operation = '${OperationTypeEnum.DEGUMMING}' AND lot_number = 'N/A' GROUP BY work_order_no HAVING SUM(physical_quantity - issued_quantity - clubbed_quantity) > 0 `
      const workOrderInfo = await manager.query(getQry)
      if(workOrderInfo.length > 0){
        return new CommonResponse(true,1,'Work order data retrieved',workOrderInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getVariantDropdown():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getQry = ` SELECT DISTINCT(pro.name) as variant,p.variant_id as variantId FROM ${appSettings.production_db} .production_inventory p LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = p.variant_id
      WHERE operation = '${OperationTypeEnum.DEGUMMING}' AND lot_number = 'N/A' GROUP BY work_order_no HAVING SUM(physical_quantity - issued_quantity - clubbed_quantity) > 0`
      const variantInfo = await manager.query(getQry)
      if(variantInfo.length > 0){
        return new CommonResponse(true,1,'Variant data retrieved',variantInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getAssignedLotInfo():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getQry = `SELECT l.lot_number as lotNumber,l.lot_type as lotType,l.remarks,l.variant_id as variantId,pro.name as lotVariant,l.quantity as lotQty,lc.work_order_no as workOrderNumber,lc.quality,lp.name as variant,lc.quantity,l.exfactory_date as exFactoryDate,l.priority,l.date as lotDate,l.material_assign_date as materialAssignDate,l.year
      FROM ${appSettings.production_db} .lot_info l
      LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = l.variant_id
      LEFT JOIN ${appSettings.production_db} .lot_code_data lc ON lc.lot_number = l.lot_number
      LEFT JOIN ${appSettings.masters_db} .products lp ON lp.product_id = lc.variant_id
      WHERE status = '${LotStatusEnum.ASSIGNED}' ORDER BY lc.created_at DESC`
      const lotInfo = await manager.query(getQry)

      if(lotInfo.length > 0){
        const lotInfoMap = new Map<string, any>()
        lotInfo.forEach(info => {
          if(!(lotInfoMap.has(info.lotNumber))){ 
            lotInfoMap.set(info.lotNumber,{lotNumber:info.lotNumber,lotType:info.lotType,remarks:info.remarks,variantId:info.variantId,lotVariant:info.lotVariant,lotQty:info.lotQty,materialInfo:[],exFactoryDate:info.exFactoryDate,priority:info.priority,lotDate:info.lotDate,materialAssignDate:info.materialAssignDate,year:info.year})
          }
          lotInfoMap.get(info.lotNumber).materialInfo.push(info)
          
        })
          return new CommonResponse(true,1,'Data retrieved',Array.from(lotInfoMap.values()))
      }else{
          return new CommonResponse(false,0,'No data found')

          
      } 
    }catch(err){
      throw err
    } 
  }

  async getLotInfo(req:LotInfoReportReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry = `SELECT l.lot_number as lotNumber,l.lot_type as lotType,l.remarks,l.variant_id as variantId,pro.name as lotVariant,l.quantity as lotQty,lc.work_order_no as workOrderNumber,lc.quality,lp.name as variant,lc.quantity,l.exfactory_date as exFactoryDate,l.priority,l.date as lotDate,l.material_assign_date as materialAssignDate,l.year
      FROM ${appSettings.production_db} .lot_info l
      LEFT JOIN ${appSettings.masters_db} .products pro ON pro.product_id = l.variant_id
      LEFT JOIN ${appSettings.production_db} .lot_code_data lc ON lc.lot_number = l.lot_number
      LEFT JOIN ${appSettings.masters_db} .products lp ON lp.product_id = lc.variant_id
      WHERE l.id > 0 `
      if(req.lotNumber){
        getQry += ` AND l.lot_number IN (${req.lotNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.workOrderNumber){
        getQry += ` AND lc.work_order_no IN (${req.workOrderNumber.map(item => `'${item}'`).join(',')})`
      }
      if(req.plantId){
        getQry += ` AND lc.plant_id = ${req.plantId}`
      }
      if(req.lotFromDate){
        getQry += ` AND l.date BETWEEN '${req.lotFromDate}' AND '${req.lotToDate}'`
      }
      getQry += ` ORDER BY l.lot_number`
      const lotInfo = await manager.query(getQry)
      if(lotInfo.length > 0){
        const lotInfoMap = new Map<string, any>()
        lotInfo.forEach(info => {
          if(!(lotInfoMap.has(info.lotNumber))){ 
            lotInfoMap.set(info.lotNumber,{lotNumber:info.lotNumber,lotType:info.lotType,remarks:info.remarks,variantId:info.variantId,lotVariant:info.lotVariant,lotQty:info.lotQty,materialInfo:[],exFactoryDate:info.exFactoryDate,priority:info.priority,lotDate:info.lotDate,materialAssignDate:info.materialAssignDate,year:info.year})
          }
          lotInfoMap.get(info.lotNumber).materialInfo.push(info)
          
        })
        return new CommonResponse(true,1,'Data retrieved',Array.from(lotInfoMap.values()))
        // return new CommonResponse(true,1,'Data retrieved',lotInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getLotNumberForLotInfo():Promise<CommonResponse>{
    const manager = getManager() 
    try{
      const getQry = `SELECT l.lot_number as lotNumber FROM ${appSettings.production_db} .lot_info l  WHERE l.id > 0 ORDER BY l.lot_number`
      const lotInfo = await manager.query(getQry)
      if(lotInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',lotInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    } 
  }

  async getWorkOrderNumberForLotInfo():Promise<CommonResponse>{
    const manager = getManager() 
    try{
      const getQry = `SELECT DISTINCT lc.work_order_no as workOrderNumber FROM ${appSettings.production_db} .lot_info l  LEFT JOIN ${appSettings.production_db} .lot_code_data lc ON lc.lot_number = l.lot_number WHERE l.id > 0 ORDER BY lc.work_order_no`
      const lotInfo = await manager.query(getQry)
      if(lotInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',lotInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    } 
  }

// async getLotInfoViewData(req?: any): Promise<CommonResponse> {
//   const manager = getManager();

//   try {

//     let query = `
//       SELECT 
//         DATE(bi.bale_date) as baleDate,
//         MIN(l.lot_number) as fromLot,
//         MAX(l.lot_number) as toLot
//       FROM ${appSettings.production_db}.lot_info l

//       LEFT JOIN ${appSettings.production_db}.lot_code_data lc
//         ON lc.lot_number = l.lot_number

//       LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi
//         ON woi.lot_number = lc.lot_number

//       LEFT JOIN ${appSettings.rm_procure_db}.bale_info bi
//         ON bi.id = woi.bale_id
//         AND bi.type = 'Export'

//       WHERE l.id > 0
//         AND l.lot_type = 'Bale'
//     `;

//     // DATE FILTER
//     if (req.fromDate && req.toDate) {
//       query += `
//         AND DATE(bi.bale_date)
//         BETWEEN '${req.fromDate}'
//         AND '${req.toDate}'
//       `;
//     }

//     query += `
//       GROUP BY DATE(bi.bale_date)
//       ORDER BY DATE(bi.bale_date)
//     `;

//     const data = await manager.query(query);

//     const responseData = data.map((item: any) => ({
//       baleDate: item.baleDate,
//       lotRange: `${item.fromLot} - ${item.toLot}`
//     }));

//     if (responseData.length > 0) {
//       return new CommonResponse(
//         true,
//         1,
//         'Data retrieved',
//         responseData
//       );
//     }

//     return new CommonResponse(false, 0, 'No data found');

//   } catch (err) {
//     throw err;
//   }
// }


async getLotInfoViewData(req?: any): Promise<CommonResponse> {
  const manager = getManager();

  try {

    let query = `
      SELECT 
        DATE(bi.bale_date) as baleDate,
        MIN(l.lot_number) as fromLot,
        MAX(l.lot_number) as toLot
      FROM ${appSettings.production_db}.lot_info l

      LEFT JOIN ${appSettings.production_db}.lot_code_data lc
        ON lc.lot_number = l.lot_number

          LEFT JOIN ${appSettings.warehouse_db}.stock s 
        ON s.lot_no = lc.lot_number

      LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi
        ON woi.lot_number = lc.lot_number

      LEFT JOIN ${appSettings.rm_procure_db}.bale_info bi
        ON bi.id = woi.bale_id
        AND bi.type = 'Export'

      WHERE l.id > 0
        AND l.lot_type = 'Bale'
    `;

    if(req.screen === 'stockOut'){
      query += `AND s.status = 'StockIn'`
    }

    // DATE FILTER
if (req.fromDate && req.toDate) {
  query += `
    AND DATE(bi.bale_date)
    BETWEEN '${req.fromDate}'
    AND '${req.toDate}'
  `;
}

// LOT FILTER
if (req.fromLot && req.toLot) {
  query += `
    AND l.lot_number BETWEEN '${req.fromLot}'
    AND '${req.toLot}'
  `;
}

    query += `
      GROUP BY DATE(bi.bale_date)
      ORDER BY DATE(bi.bale_date)
    `;

    const data = await manager.query(query);

    const responseData = data.map((item: any) => ({
      baleDate: item.baleDate,
      lotRange: `${item.fromLot} - ${item.toLot}`
    }));

    if (responseData.length > 0) {
      return new CommonResponse(
        true,
        1,
        'Data retrieved',
        responseData
      );
    }

    return new CommonResponse(false, 0, 'No data found');

  } catch (err) {
    throw err;
  }
}

async getExportLotDetailView(req?: any): Promise<CommonResponse> {

  const manager = getManager();

  try {

    let query = `
      SELECT
        DATE(bi.bale_date) as baleDate,
        bi.bale_no as baleNumber,
        l.lot_number as lotNumber,
        pro.name as variant,
        lc.quality,
        SUM(lc.quantity) AS quantity

      FROM ${appSettings.production_db}.lot_info l

      LEFT JOIN ${appSettings.production_db}.lot_code_data lc
        ON lc.lot_number = l.lot_number

          LEFT JOIN ${appSettings.warehouse_db}.stock s 
        ON s.lot_no = lc.lot_number

      LEFT JOIN ${appSettings.rm_procure_db}.work_order_items woi
        ON woi.lot_number = lc.lot_number

      LEFT JOIN ${appSettings.rm_procure_db}.bale_info bi
        ON bi.id = woi.bale_id
        AND bi.type = 'Export'

      LEFT JOIN ${appSettings.masters_db}.products pro
        ON pro.product_id = bi.variant_id

      WHERE l.id > 0
        AND l.lot_type = 'Bale'
    `;

    if(req.screen === 'stockOut'){
      query += `AND s.status = 'StockIn'`
    }

    // BALE DATE FILTER
    if (req.baleDate) {
      query += `
        AND DATE(bi.bale_date) = '${req.baleDate}'
      `;
    }

    query += `
    GROUP BY
    DATE(bi.bale_date),
    bi.bale_no,
    l.lot_number,
    pro.name,
    lc.quality 
      ORDER BY l.lot_number ASC
    `;

    const data = await manager.query(query);

    if (data.length > 0) {

      const responseData = data.map((item: any) => ({
        baleDate: item.baleDate,
        baleNumber: item.baleNumber,
        lotNumber: item.lotNumber,
        variant: item.variant,
        quality: item.quality,
        quantity: item.quantity
      }));

      return new CommonResponse(
        true,
        1,
        'Data retrieved',
        responseData
      );
    }

    return new CommonResponse(false, 0, 'No data found');

  } catch (err) {
    throw err;
  }
}

 async getFromToLotNumberDropdown(): Promise<CommonResponse> {
  const manager = getManager();

  try {
    const getQry = `
      SELECT DISTINCT 
        l.lot_number AS lotNumber
      FROM ${appSettings.production_db}.lot_info l
      WHERE l.id > 0
      ORDER BY 
        LEFT(l.lot_number, 
          CASE 
            WHEN LOCATE('/', l.lot_number) > 0 THEN LOCATE('/', l.lot_number) - 1
            WHEN LOCATE('-', l.lot_number) > 0 THEN LOCATE('-', l.lot_number) - 1
            ELSE LENGTH(l.lot_number)
          END
        ) ASC,
        CAST(
          SUBSTRING_INDEX(
            REPLACE(l.lot_number, '-', '/'),
            '/',
            -1
          ) AS UNSIGNED
        ) ASC
    `;

    const lotInfo = await manager.query(getQry);

    if (lotInfo.length > 0) {
      return new CommonResponse(
        true,
        1,
        'Data retrieved',
        lotInfo
      );
    } else {
      return new CommonResponse(
        false,
        0,
        'No data found'
      );
    }
  } catch (err) {
    throw err;
  }
}
}

